import(/* webpackMode: "eager", webpackExports: ["NotInApp"] */ "/home/fftu/cooking-videos/src/app/(main)/pricing/not-in-app.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingClient"] */ "/home/fftu/cooking-videos/src/app/(main)/pricing/pricing-client.tsx");
